var jvc_RM_C1251G = {
    name: "RM_C1251G",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,250,183,136],
        },
        {
            // function: "input",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,250,239,16],
        },
        {
            function: "display",
            name: "display",
            icon: "display",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,254,252,64],
        },
        {
            function: "sleep_timer",
            name: "sleep_timer",
            icon: "sleep_timer",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,250,254,32],
        },
        {
            function: "sound",
            name: "sound",
            icon: "sound",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,253,246,32],
        },
        {
            function: "KEY_VIDEO",
            name: "KEY_VIDEO",
            icon: "KEY_VIDEO",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,251,95,16],
        },
        {
            function: "theater_pro",
            name: "theater_pro",
            icon: "theater_pro",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,251,109,68],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,254,175,16],
        },
        {
            function: "aspect",
            name: "aspect",
            icon: "aspect",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,250,238,136],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,251,238,32],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,253,238,32],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,250,247,16],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,254,238,32],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,251,119,16],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,253,119,16],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,250,187,136],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,255,110,32],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,251,183,16],
        },
        {
            function: "X_KEY_0+",
            name: "X_KEY_0+",
            icon: "X_KEY_0+",
            command: [36,0,4,109,2,191,5,109,2,236,1,175,30,232,14,102,2,67,65,58,170,247,162],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,255,220,64],
        },
        {
            // function: "KEY_ENTER",
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,251,126,32],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,251,175,16],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,255,94,32],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,253,87,136],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,250,171,196],
        },
        {
            function: "cc",
            name: "cc",
            icon: "cc",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,253,95,16],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,253,170,196],
        },
        {
            // function: "KEY_EXIT",
            function: "KEY_BACK",
            name: "KEY_BACK",
            icon: "KEY_BACK",
            command: [36,0,4,109,2,236,1,109,2,191,5,175,30,232,14,102,2,67,65,43,253,117,68],
        },
    ]
}
export default jvc_RM_C1251G